<p-avatar class="step-avatar" [label]="label()" shape="circle"></p-avatar>
<div class="upload-header">
  <h3>{{ translationPrefix() + '.heading' | translate }}</h3>
  <span class="subheading-shadow">{{
    translationPrefix() + '.subheading' | translate
  }}</span>
</div>
